import { useState } from 'react'
import DashboardMembersList from '../../../../../components/Lists/DashboardMembersList'
import Select from '../../../../../components/Inputs/Select'
import { DateTime } from 'luxon'

import {
  InfoContainer,
  FilterContainer,
  SubTitle
} from '../../styles'

export default function MembersByFrequency ({
  data: members,
  order = 'desc',
  month = DateTime.now ().month,
  year = DateTime.now ().year
}) {
  const selectedDate = DateTime.local (year, month).setLocale ('pt-BR')
  const formattedDate = selectedDate.toFormat ('MMM yyyy')
  const [monthFilter, setMonthFilter] = useState ({
    label: formattedDate,
    value: formattedDate
  })

  if (!members || Object.keys (members).length === 0) {
    return null
  }

  return (
    <InfoContainer>
      <SubTitle>
        Top 10 membros que {order === 'desc' ? 'mais' : 'menos'} agendaram
      </SubTitle>
      <FilterContainer>
        <Select
          placeholder='Período...'
          value={monthFilter}
          options={Object.keys (members).map (month => ({
            label: month, value: month
          }))}
          onChange={(_, option) => setMonthFilter (option)}
          containerStyles={{width: 250}}
        />
      </FilterContainer>
      <DashboardMembersList members={members[monthFilter.value]}/>
    </InfoContainer>
  )
}
